import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { useTranslation } from "react-i18next"
import { LanguageService } from "services/languageService"

const languages = [
  {
    code: "en",
    name: "English",
    flag: "🇬🇧",
  },
  {
    code: "pt",
    name: "Português (BR)",
    flag: "🇧🇷",
  },
]

export function LanguagePicker() {
  const { i18n } = useTranslation()
  const currentLanguage = languages.find((l) => l.code === i18n.language) || languages[0]

  const handleLanguageChange = (languageCode: string) => {
    // Mark that user has made a direct choice
    LanguageService.markUserChoice()
    // Save the language choice
    LanguageService.saveLanguage(languageCode)
    // Change the language
    i18n.changeLanguage(languageCode)
  }

  return (
    <div className="disable-strapi">
      <DropdownMenu>
        <DropdownMenuTrigger className="disable-strapi flex items-center gap-2 px-3 py-2 hover:bg-gray-700 transition-colors focus:outline-none rounded">
          <span className="text-lg">{currentLanguage.flag}</span>
          <span className="text-sm text-white">{currentLanguage.name}</span>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-[180px] bg-gray-800 border-gray-600">
          {languages.map((language) => (
            <DropdownMenuItem
              key={language.code}
              className="flex cursor-pointer items-center gap-2 text-gray-200 hover:bg-gray-700 hover:text-white"
              onClick={() => handleLanguageChange(language.code)}
            >
              <span className="text-lg">{language.flag}</span>
              <span>{language.name}</span>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
